import { render, staticRenderFns } from "./identify.vue?vue&type=template&id=056d6434&scoped=true"
import script from "./identify.vue?vue&type=script&lang=js"
export * from "./identify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056d6434",
  null
  
)

export default component.exports